import { defineComponent as l, computed as r, openBlock as s, createElementBlock as n, createVNode as c, Transition as m, withCtx as d, mergeProps as u, renderSlot as f, createCommentVNode as p } from "vue";
import { tw as e } from "../../utils/tailwind.js";
const b = { "aria-live": "polite" }, B = /* @__PURE__ */ l({
  name: "RevStickyBar",
  inheritAttrs: !1,
  __name: "StickyBar",
  props: {
    position: { default: "bottom" },
    visible: { type: Boolean, default: !0 },
    snapToViewPort: { type: Boolean, default: !0 }
  },
  setup(t) {
    const i = r(() => [
      e`bg-surface-default-low border-static-default-low inset-x-0 z-10 border-solid px-24`,
      {
        top: e`top-0 border-b pb-12 pt-[calc(0.75rem+env(safe-area-inset-top))] safari-mobile-26:pt-0`,
        bottom: e`bottom-0 border-t pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-12 safari-mobile-26:pb-[env(safe-area-inset-bottom)]`
      }[t.position],
      t.snapToViewPort && e`fixed`
    ]), o = r(() => ({
      top: e`-translate-y-full`,
      bottom: e`translate-y-full`
    })[t.position]);
    return (a, v) => (s(), n("div", b, [
      c(m, {
        "enter-active-class": "transition duration-300 ease-in motion-reduce:transition-none",
        "enter-from-class": o.value,
        "enter-to-class": "translate-y-0",
        "leave-active-class": "transition duration-300 ease-out motion-reduce:transition-none",
        "leave-to-class": o.value
      }, {
        default: d(() => [
          t.visible ? (s(), n("div", u({ key: 0 }, a.$attrs, { class: i.value }), [
            f(a.$slots, "default")
          ], 16)) : p("", !0)
        ]),
        _: 3
      }, 8, ["enter-from-class", "leave-to-class"])
    ]));
  }
});
export {
  B as default
};
